import { render } from "./FooterLink.vue?vue&type=template&id=7f467416&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=7f467416&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f467416"]])

export default __exports__